import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { leaveOptions } from "../../utils/constant";
import { toast, ToastContainer } from "react-toastify";

const LeaveModal = ({
    show,
    onHide,
    leaveDate,
    month,
    year,
    userState,
    onSuccess
}) => {

    // state for data
    const [leaveType, setLeaveType] = useState("");
    const [reason, setReason] = useState("");
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // date logic
    const today = new Date();

    const selectedDate = new Date(year, month - 1, leaveDate?.date);

    const isToday =
        today.getDate() === selectedDate.getDate() &&
        today.getMonth() === selectedDate.getMonth() &&
        today.getFullYear() === selectedDate.getFullYear();

    // filter leave type data
    const filteredLeaveOptions = isToday
        ? leaveOptions.filter(option => option.value === "SL")
        : leaveOptions;

    // validation
    const validateForm = () => {
        let newErrors = {};

        if (!leaveType) {
            newErrors.leaveType = "Please select leave type";
        }

        if (!reason.trim()) {
            newErrors.reason = "Reason is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // submit API
    const handleSubmitLeave = async () => {
        if (!validateForm()) return;

        try {
            setLoading(true);

            const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(leaveDate.date).padStart(2, "0")}`;

            const payload = {
                empId: userState?.empId,
                firstName: userState?.firstName,
                lastName: userState?.lastName,
                workEmail: userState?.workEmail,
                contactNo: userState?.contactNo,
                leaveType: leaveType?.value,
                fromDate: formattedDate,
                toDate: formattedDate,
                reason: reason,
            };

            const response = await fetch(
                process.env.REACT_APP_BASE_URL + "/leave/applyleave",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const data = await response.json();
            if (data.status === 200) {
                toast.success(data.message, {
                    toastId: "leave-success"
                });
                setLeaveType("");
                setReason("");
                setErrors({});
                onSuccess && onSuccess();
                handleClose();
            } else {
                toast.error(data.message || "Something went wrong ❌", {
                    toastId: "leave-error"
                });
                // setLeaveType("");
                // setReason("");
                // setErrors({});
            }

        } catch (error) {
            console.error(error);
            toast.error("API Error ❌");
        } finally {
            setLoading(false);
        }
    };

    // reset + close
    const handleClose = () => {
        setLeaveType("");
        setReason("");
        setErrors({});
        onHide();
    };

    return (
        <>
            {/* <ToastContainer /> */}
            <Modal show={show} onHide={handleClose}>

                <Modal.Header closeButton>
                    <Modal.Title>
                        Apply Leave ({leaveDate?.date}-{month}-{year})
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {leaveDate?.leaveInfo ? (
                        <>
                            {leaveDate.leaveInfo.status === "Pending" && (
                                <div className="alert alert-warning text-center">
                                    ⏳ Your leave is already applied and pending approval
                                </div>
                            )}

                            {leaveDate.leaveInfo.status === "Approved" && (
                                <div className="alert alert-success text-center">
                                    ✅ Your leave is approved
                                </div>
                            )}

                            {leaveDate.leaveInfo.status === "Rejected" && (
                                <div className="alert alert-danger text-center">
                                    ❌ Your leave is rejected <br />
                                    <b>Reason:</b> {leaveDate.leaveInfo.rejectReason}
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Leave Type <span className="requiredfield">*</span>
                                </Form.Label>

                                <Select
                                    isMulti={false}
                                    isSearchable
                                    options={filteredLeaveOptions}
                                    value={leaveType}
                                    onChange={(option) => setLeaveType(option)}
                                />

                                {errors.leaveType && (
                                    <p style={{ color: "red", fontSize: "12px" }}>
                                        {errors.leaveType}
                                    </p>
                                )}
                            </Form.Group>

                            <Form.Group>
                                <Form.Label>
                                    Reason <span className="requiredfield">*</span>
                                </Form.Label>

                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter your leave reason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                />
                            </Form.Group>

                            {errors.reason && (
                                <p style={{ color: "red", fontSize: "12px" }}>
                                    {errors.reason}
                                </p>
                            )}
                        </>
                    )}
                </Modal.Body>

                {!leaveDate?.leaveInfo && (
                    <Modal.Footer>
                        <Button
                            className="primaryBtn"
                            onClick={handleSubmitLeave}
                            disabled={loading}
                        >
                            Submit
                        </Button>
                    </Modal.Footer>
                )}
            </Modal>
        </>
    );
};

export default LeaveModal;